import {TreeAction, ITreeItem} from "./types";

export interface TreeItemMove {
  dropType: 'insertAfter' | 'insertBefore' | 'insertChild';
  dropTargetId: string,
  movedItemId: string;
}

export abstract class TreeSource<T extends ITreeItem> {
  abstract data: {
    items: Record<string, ITreeItem>,
    pinnedLength: number
  };

  abstract getTopLevelItems(renderingRootId?: string): T[];

  getPathToItem = (targetId: string) => targetId.split('/').slice(0, -1);

  /* expected to update the mobx observable this.items */
  abstract handleMove(moveParams: TreeItemMove): void;

  /* expected to update observable item */
  abstract toggle(treeItemId: string, newState?: boolean): void

  processEvent = (action: TreeAction): void => {
    const movedItem = this.data.items[action.itemId];
    if (!movedItem) {
      return;
    }

    if (action.type === 'instruction') {
      const targetItem = this.data.items[action.targetId];
      if (!targetItem) {
        return;
      }
      const instruction = action.instruction;

      if (instruction.type === 'reparent') {
        const path = targetItem.id.split('/');
        const desiredId = path.slice(0, instruction.desiredLevel + 2).join('/');

        this.handleMove({
          dropType: 'insertAfter',
          dropTargetId: desiredId,
          movedItemId: action.itemId,
        });
        return
      }

      // the rest of the actions require you to drop on something else
      if (action.itemId === action.targetId) {
        return;
      }

      if (instruction.type === 'reorder-above') {
        this.handleMove({
          dropType: 'insertBefore',
          dropTargetId: action.targetId,
          movedItemId: action.itemId,
        });
        return;
      }

      if (instruction.type === 'reorder-below') {
        this.handleMove({
          dropType: 'insertAfter',
          dropTargetId: action.targetId,
          movedItemId: action.itemId,
        });
        return;
      }

      if (instruction.type === 'make-child') {
        this.handleMove({
          dropType: 'insertChild',
          dropTargetId: action.targetId,
          movedItemId: action.itemId,
        });
        return;
      }

      console.warn('TODO: action not implemented', instruction);
      return;
    }

    if (action.type === 'toggle') {
      this.toggle(action.itemId);
      return;
    }

    if (action.type === 'expand') {
      this.toggle(action.itemId, true);
      return;
    }

    if (action.type === 'collapse') {
      this.toggle(action.itemId, false);
      return;
    }

    return;
  }

  hasChildren(item: T): boolean {
    return item.childrenIds.length > 0;
  };
}
